// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53bd694a","239":"34e9ef70","453":"89c6e075","732":"83711f9a"}[chunkId] + ".chunk.js";
};